import { resetClipData } from "@/components/reports/ClipDialog.vue";
import { loadOrthoStage } from "@/components/ortho/OrthoPlanMode";
import { sendOrthoRemoveStageRequest } from "@/api/orthoApi";
import { sendResetCaseRequest } from "@/api/toothApi";
import {
  DicomInitialized,
  resetProjections,
  updateAppLayout,
} from "@/components/dicom/DicomManager.js";

async function resetAll() {
  resetClipData();

  $("#main_div").css("background-color", vueApp.backgroundColor);
  viewer.scene.background = new THREE.Color(vueApp.backgroundColor);
  vueApp.isWhite = isWhiteColor(vueApp.backgroundColor);
  // vueApp.isWhite = true;

  vueApp.leaveModes();

  vueApp.implants.forEach((element) => {
    viewer.remove_model(element.id);
  });
  vueApp.implants.splice(0, vueApp.implants.length);

  vueApp.crowns.forEach((element) => {
    viewer.remove_model(element.id);
  });
  vueApp.crowns.splice(0, vueApp.crowns.length);

  viewer.camera.lookAt(0, 0, 0);
  viewer.controls.target = new THREE.Vector3(0, 0, 0);
  resetCameraUp();
  viewer.camera.position.x = 0;
  viewer.camera.position.y = 0;
  viewer.camera.position.z = defaultZoom;
  viewer.camera.updateProjectionMatrix();
  viewer.controls.update();

  vueApp.bonesColor = vueApp.baseData.bonesColor;
  vueApp.bonesOpacity = vueApp.baseData.bonesOpacity;
  vueApp.teethColor = vueApp.baseData.teethColor;
  vueApp.teethOpacity = vueApp.baseData.teethOpacity;
  vueApp.isRandomTeethColor = false;

  if (opacityInitialized) {
    $("#bones_opacity").slider("value", vueApp.bonesOpacity);
    $("#teeth_opacity").slider("value", vueApp.teethOpacity);
  }

  resetTeeth(true);

  vueApp.bones.forEach((item) => {
    var savedBone = vueApp.baseData.bones.find(function (data, index) {
      return data.name === item.name;
    });
    if (savedBone) {
      item.isVisible = savedBone.isVisible;
      item.color = savedBone.color;
    } else {
      item.color = vueApp.bonesColor;
    }
    itemVisibilityChanged(item, item.color, vueApp.bonesOpacity);
  });

  vueApp.dentations.forEach((item) => {
    var savedDentation = vueApp.baseData.dentations.find(function (
      data,
      index
    ) {
      return data.name === item.name;
    });
    if (savedDentation) {
      item.isVisible = savedDentation.isVisible;
    }
    //itemVisibilityChanged(item, item.color, vueApp.bonesOpacity);
  });

  vueApp.nerves.forEach((item) => {
    var savedNerve = vueApp.baseData.nerves.find(function (data, index) {
      return data.name === item.name;
    });
    if (savedNerve) {
      item.isVisible = savedNerve.isVisible;
    }
    itemVisibilityChanged(item, vueApp.nervesColor);
  });

  vueApp.gingivae.forEach((item) => {
    var saved = vueApp.baseData.gingivae.find(function (data, index) {
      return data.name === item.name;
    });
    if (saved) {
      item.isVisible = saved.isVisible;
    }
    itemVisibilityChanged(item, vueApp.gingivaeColor);
  });

  vueApp.airways.forEach((item) => {
    var saved = vueApp.baseData.airways.find(function (data, index) {
      return data.name === item.name;
    });
    if (saved) {
      item.isVisible = saved.isVisible;
    }
    itemVisibilityChanged(item, vueApp.airwaysColor);
  });

  vueApp.$emit("visibilityChanged", "resetAll");

  if (DicomInitialized) {
    if (vueApp.isDicomOpen) {
      updateAppLayout();
    }
    resetProjections();
  }

  if (vueApp.orthoStages && vueApp.orthoStages.length) {
    try {
      resetOrthoStages();
      vueApp.saveData();

      showLoader();

      let urls = await sendResetCaseRequest();
      if (urls && urls.desktopZipUrl && urls.inputJsonUrl) {
        console.log("reset urls", urls);
        let jsonLocation = (vueApp.jsonLocation = urls.inputJsonUrl);

        fetch(jsonLocation, {
          cache: "no-cache",
        })
          .then(function (response) {
            response.text().then(async (text) => {
              let model = JSON.parse(text);
              model.data.mobileZip = model.data.desktopZip = urls.desktopZipUrl;
              vueApp.isStlLoaded = allLoaded = stlShown = false;
              clearViewer();
              vueApp.initApp(model);
              // initModel(model);
            });
          })
          .catch((error) => {
            console.error("Error in input JSON download: ", error);
            hideLoader();
          });
      } else {
        hideLoader();
      }
    } catch (error) {
      console.error("Error in resetAll: ", error);
      hideLoader();
    }
  }
}

function clearViewer() {
  viewer.controls.removeEventListener("change", onCameraChange);
  viewer.clean();
  viewer.renderer.domElement.remove();
  viewer = null;
}

function showLoader() {
  $("#loaderText").html(`Loading data... Please wait`);
  $("#loaderText2").html(``);
  $("#loaderText3").html(``);
  $id("loader").style.display = "block";
  //   $id("stl_cont").style.visibility = "hidden";
}

function hideLoader() {
  $id("loader").style.display = "none";
}

function resetOrthoStages() {
  if (vueApp.orthoStages && vueApp.orthoStages.length) {
    vueApp.orthoStages.forEach((stage) => {
      sendOrthoRemoveStageRequest(stage);
    });
    vueApp.orthoStages.splice(0, vueApp.orthoStages.length);
    loadOrthoStage(-1, false);
  }
}

function resetTeeth(fullReset) {
  var savedGroups = vueApp.baseData.dentations.reduce(function (a, b) {
    return a.concat(b.groups);
  }, []);
  var savedTeeth = savedGroups.reduce(function (a, b) {
    return a.concat(b.teeth);
  }, []);

  vueApp.allTeeth.forEach((tooth) => {
    var savedTooth = savedTeeth.find(function (data, index) {
      return data.filename === tooth.filename;
    });
    if (savedTooth) {
      tooth.isVisible = savedTooth.isVisible;
      if (fullReset) {
        tooth.color = savedTooth.color;
      }
    }

    if (tooth.randomColor == noRandomColor) {
      tooth.randomColor = null;
    }
    var color =
      vueApp.isRandomTeethColor && tooth.randomColor != null
        ? tooth.randomColor
        : tooth.color;
    itemVisibilityChanged(tooth, color, vueApp.teethOpacity);

    var mesh = viewer.get_model_mesh(tooth.id);
    var savedPos = tooth.defaultPosition;
    mesh.position.set(savedPos.x, savedPos.y, savedPos.z);
    mesh.rotation.set(0, 0, 0);

    tooth.savedPosition = {
      x: mesh.position.x,
      y: mesh.position.y,
      z: mesh.position.z,
    };
    tooth.savedRotation = {
      x: mesh.rotation.x,
      y: mesh.rotation.y,
      z: mesh.rotation.z,
    };
  });
  vueApp.$emit("visibilityChanged", "resetTeeth");

  if (!fullReset) {
    if (DicomInitialized) {
      if (vueApp.isDicomOpen) {
        updateAppLayout();
      }
      resetProjections();
    }
  }
}

export { resetAll, resetTeeth };
